import { render, staticRenderFns } from "./smsVendorSetting.vue?vue&type=template&id=31c06d0e&lang=pug"
import script from "./smsVendorSetting.vue?vue&type=script&lang=js"
export * from "./smsVendorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports